/*
 * Returns the full make, model and year of a vehicle entity.
 */
export function vehicleToMakeFull(record: {
	make?: { name?: string };
	model?: { name?: string };
	year?: number;
}): string {
	// Check
	if (!record) {
		return '';
	}

	return `${record.make ? record.make.name + ' ' : ''}${record.model ? record.model.name : ''} ${record.year ? record.year : ''}`;
}
